import React from 'react';

import UwReportsItem from './UwReportsItem';

export const config = {
  createdDate: {
    label: 'Date',
    width: '25%',
    colSpan: ({ createdDate }) => createdDate?.colSpan,
    customStyles: ({ createdDate }) => createdDate?.customStyles,
    content: ({ createdDate }) => createdDate?.content ?? 'Date',
  },
  informationalAlerts: {
    label: 'Informational',
    width: '25%',
    content: () => 'Informational',
  },
  warningAlerts: {
    label: 'Warning',
    width: '25%',
    content: () => 'Warning',
  },
  severeAlerts: {
    label: 'Severe',
    width: '25%',
    content: () => 'Severe',
  },
};

export const getItemRow = item => ({
  createdDate: {
    position: 1,
    colSpan: 4,
    content: <UwReportsItem item={item} />,
  },
});
